import React from "react";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Typography,
} from "@mui/material";

import HTMLRenderer from "../../../Common/Html/HTMLRenderer";

import CENTAvatar from "../CENTAvatar";
import RenderDate from "../../../Common/Date/RenderDate";

function TermCard({ term, onClick }) {
    const title = term?.title?.length > 0 ? term.title : "Term";
    const dateCreated = !!term?.date ? (
        <RenderDate date={term.date} />
    ) : (
        "Not specified"
    );
    const description =
        term?.description?.length > 0 ? term.description : "...";
    const canUpdate = !!(term?.canUpdate && term?.form?.elements?.length > 0);

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={<CENTAvatar type="term" />}
                title={
                    <Typography component="h2" className="card-header-title">
                        {title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {dateCreated}
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <HTMLRenderer html={description} />
                </Box>
            </CardContent>

            {canUpdate && (
                <CardActions>
                    <Button
                        key="save"
                        variant="contained"
                        color="primary"
                        disableElevation={true}
                        onClick={onClick}
                    >
                        Confirm
                    </Button>
                </CardActions>
            )}
        </Card>
    );
}

export default TermCard;
